import { withInstall } from '@vuemap/vue-amap-util'
import Traffic from './Traffic.vue'

export const ElAmapLayerTraffic = withInstall(Traffic)
export default ElAmapLayerTraffic
